import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IApplicationState {
  sidebarOpen: boolean;
  windowWidth: number;
}

const initialState: IApplicationState = {
  sidebarOpen: false,
  windowWidth: window.innerWidth,
};

export const applicationSlice = createSlice({
  initialState,
  name: 'application',
  reducers: {
    saveAppWidth: (state, action: PayloadAction<number>) => {
      state.windowWidth = action.payload;
    },
    setIsSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
  },
});

export const { saveAppWidth } = applicationSlice.actions;
